module.exports = __webpack_public_path__ + "img/empty-order.07822152.png";